"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.74 5.584c-.459.369-.853.864-1.141 1.332a.7.7 0 0 1-1.194-.003c-.286-.47-.677-.961-1.133-1.328-.457-.367-.937-.578-1.422-.578-.782 0-1.363.258-1.758.71-.406.463-.692 1.218-.692 2.347 0 1.316.72 2.65 1.75 3.865 1.02 1.202 2.265 2.2 3.148 2.833.429.308.98.308 1.409 0 .881-.634 2.127-1.63 3.145-2.833 1.03-1.216 1.748-2.549 1.748-3.865 0-1.13-.286-1.881-.691-2.343-.395-.451-.977-.71-1.759-.714-.473-.002-.95.206-1.41.577m-.878-1.09c.613-.495 1.394-.891 2.296-.887 1.107.006 2.098.386 2.804 1.19C16.657 5.592 17 6.713 17 8.065c0 1.807-.97 3.458-2.08 4.77-1.122 1.325-2.47 2.399-3.396 3.065a2.59 2.59 0 0 1-3.043 0c-.927-.665-2.275-1.74-3.399-3.065C3.97 11.523 3 9.872 3 8.064c0-1.352.343-2.475 1.039-3.27.706-.806 1.7-1.187 2.811-1.187.904 0 1.684.392 2.3.887.319.257.605.55.855.853a6.07 6.07 0 0 1 .857-.854",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HeartIcon20.js.map